import { render, staticRenderFns } from "./PDPPricingInfo.vue?vue&type=template&id=2ce7c928&scoped=true&"
import script from "./PDPPricingInfo.vue?vue&type=script&lang=js&"
export * from "./PDPPricingInfo.vue?vue&type=script&lang=js&"
import style0 from "./PDPPricingInfo.vue?vue&type=style&index=0&id=2ce7c928&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce7c928",
  null
  
)

export default component.exports